import { faBars, faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useLoader } from "../../Context/KYCApplicationContext/LoaderContext/LoaderContext";
import { SessionKeyEnum } from "../../Enumeration/SessionKeyEnum";
import useStaticData from "../CsplControls/CsplAch/UseStaticData";
import { AlertResponseEnum } from "../CsplModal/AlertResponse";
import WidgetChangeAlertModal from "../CsplModal/WidgetChangeAlertModal";
import OtpResource from "../Widgets/LoginPage/loginResource";

function Banner({ currentFormData, saveWidgetToDraft }) {
  const { logout } = OtpResource();

  const [clicked, setClicked] = useState(false); // loader state

  // manage the state of the logout alert modal
  const [isLogoutAlertOpen, setIsLogoutAlertOpen] = useState(false);

  const [, getLookupData] = useStaticData();

  const [homePageUrl, setHomePageUrl] = useState("");

  const { showLoader, hideLoader } = useLoader();

  const mode = sessionStorage.getItem(SessionKeyEnum.EncryptedMode);

  // sideBar Show
  const menuOpener = () => {
    document.getElementById("menubar").style.left = "0px";
    document.querySelector(".close_overlay").style.display = "block";
  };
  // sideBar Close
  const menuCloser = () => {
    document.getElementById("menubar").style.left = "-400px";
    document.querySelector(".close_overlay").style.display = "none";
  };

  const handleLogout = () => {
    setIsLogoutAlertOpen(true); // show confirmation modal
  };

  useEffect(() => {
    getLookupData("kycConfig").then(
      (res) => {
        if (res != null) {
          const homePageUrl = res?.rd_home_page;
          setHomePageUrl(homePageUrl);
        }
      },
      (error) => {},
    );
  }, []);

  const performLogout = async () => {
    showLoader(); // show loader
    try {
      await logout(); // call your API
      sessionStorage.clear(); // remove all KYC session info
      window.location.href = homePageUrl;
    } catch (err) {
      console.error("Logout API failed", err);
    } finally {
      hideLoader();
      setIsLogoutAlertOpen(false);
    }
  };

  // Modal handler
  const onLogoutModalClose = (response) => {
    if (response === AlertResponseEnum.Cancel) {
      return; // user cancelled logout
    } else if (response === AlertResponseEnum.DontSave) {
      performLogout(); // logout immediately
    } else if (response === AlertResponseEnum.Save) {
      // If you want to save form data before logout
      saveWidgetToDraft(currentFormData)
        .then(() => performLogout())
        .catch(() => performLogout()); // fallback logout if save fails
    }
  };
  return (
    <section>
      <WidgetChangeAlertModal
        isModalOpen={isLogoutAlertOpen}
        setIsModalOpen={setIsLogoutAlertOpen}
        currentWidget={{ widgetName: "Logout" }}
        data={null}
        onClose={onLogoutModalClose}
      />
      {/* <CsplBackDropLoading showLoading={clicked} /> */}

      <div className="w-100 banner py-2 d-flex align-items-center justify-content-between px-3">
        {/* Empty div to balance left side (optional) */}
        <div style={{ width: "40px" }}></div>

        {/* Logo Center */}
        <div className="text-center flex-grow-1">
          <img src="/Assets/Images/Logo.png" alt="#" className="banner_img" />
        </div>

        {/* Logout Right */}
        {mode === "RU5UUlk" && (
          <div
            className="logout_box d-flex align-items-center justify-content-center px-3"
            onClick={handleLogout}
          >
            <FontAwesomeIcon icon={faPowerOff} className="me-2" />
            Leave
          </div>
        )}
      </div>
      <div>
        <FontAwesomeIcon
          icon={faBars}
          className="menubar_icon"
          aria-hidden="true"
          onClick={menuOpener}
        ></FontAwesomeIcon>
        <div className="close_overlay" onClick={menuCloser}></div>
      </div>
    </section>
  );
}

export default Banner;
